import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
} from "@material-ui/core";
import { useStyles } from "./JobTagDetailTable";

export interface AddDuplicateDetailingScheduleDialogProps {
  open: boolean;
  fromScheduleId: string;
  fromScheduleName: string;
  onClose: (
    fromScheduleId: string,
    scheduleId: string,
    scheduleName: string
  ) => void;
}
export function AddDuplicateDetailingScheduleDialog(
  props: AddDuplicateDetailingScheduleDialogProps
) {
  const classes = useStyles();
  const [scheduleId, setScheduleId] = useState("");
  const [scheduleName, setScheduleName] = useState("");

  const { onClose, fromScheduleId, fromScheduleName, open } = props;

  const handleClose = () => {
    onClose(fromScheduleId, "", "");
  };

  function handleCloseDialog(arg0: boolean): void {
    onClose(fromScheduleId, "", "");
  }

  function handleSubmit(): void {
    if (scheduleName.length === 0 || scheduleId.length === 0) {
      return;
    }
    onClose(fromScheduleId, scheduleId, scheduleName);
    setScheduleId("");
    setScheduleName("");
  }

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title">New Detailing Schedule</DialogTitle>
      <DialogContent>
        <div>From Details:</div>
        <div style={{ paddingBottom: 10 }}>
          <span> Schedule ID: {fromScheduleId}</span>
          <span style={{ paddingLeft: 10 }}>Area: {fromScheduleName}</span>
        </div>

        <TextField
          placeholder="Enter Schedule ID"
          fullWidth
          variant="filled"
          required
          name="scheduleId"
          value={scheduleId}
          type="number"
          onChange={(e) => setScheduleId(e.target.value)}
        />

        <div style={{ paddingTop: 10 }}>
          <TextField
            placeholder="Enter Schedule"
            fullWidth
            variant="filled"
            required
            name="name"
            value={scheduleName}
            onChange={(e) => setScheduleName(e.target.value)}
          />
        </div>
      </DialogContent>

      <DialogActions>
        {/* {error &&
                <span style={{color: "red"}}>{error}</span>
            } */}
        <Button color="secondary" onClick={() => handleCloseDialog(false)}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="secondary">
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}
